(ns ui.view.card.entity-list.util
  (:require
   [ui.util :as uu]
   [common.schema.registry :as registry]
   [common.schema.data-types :as data-types]))

;; Generic utils for entity listing cards (fees, tasks etc.)

(defn resolve-row-data
  [{:keys [entity column-fields entities-by-id tenant tenant-schema]}]
  (let [entity-id (:db/id entity)
        data (->> column-fields
                  (mapv
                   (fn [field]
                     (let [value (get entity field)
                           field-schema (registry/get-field-schema tenant-schema field)
                           data-type (:field/data-type field-schema)
                           numeric? (-> data-type
                                        data-types/numeric-data-types
                                        boolean)
                           currency? (= data-type :data.type/currency-value)
                           materialized-value (uu/field-value->materialized-value
                                               {:field field
                                                :value value
                                                :tenant tenant
                                                :tenant-schema tenant-schema
                                                :id->entity entities-by-id
                                                :entity entity
                                                :show-currency? true})

                           ;; TODO: What other fields need to be converted?
                           value (if (and value currency?)
                                   (uu/bigdec->float value)
                                   value)

                           value-map {:value value
                                      :materialized-value materialized-value
                                      :numeric? numeric?}]
                       [field value-map])))
                  (into {}))]
    (merge data
           {:db/id {:value entity-id
                    :materialized-value entity-id}})))

(defn entities->table-row-data
  [{:keys [entities column-fields entities-by-id tenant tenant-schema]}]
  (->> entities
       (mapv (fn [entity]
               (resolve-row-data {:entity entity
                                  :column-fields column-fields
                                  :entities-by-id entities-by-id
                                  :tenant tenant
                                  :tenant-schema tenant-schema})))))
